/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

const actionTypes = {
  APPLICATION_ERROR: 'APPLICATION_ERROR',
  SUCCESS_ACTION: 'SUCCESS_ACTION',
  UNAUTHORIZED_ERROR: 'UNAUTHORIZED_ERROR',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  SERVER_ERROR: 'SERVER_ERROR',

  SPACES_SPINNER: 'SPACES_SPINNER',
  SPACE_CHANGE_INITIAL_STATE: 'SPACE_CHANGE_INITIAL_STATE',
  LARGE_FETCH_ACTIVE: 'LARGE_FETCH_ACTIVE',
  CLEAR_ACTIVE_SPINNER: 'CLEAR_ACTIVE_SPINNER',

  DRAG_STATUS: 'DRAG_STATUS',
  SET_HOVER_BACKGROUND: 'SET_HOVER_BACKGROUND',

  VIEW_GETTING_READY: 'VIEW_GETTING_READY',
  VIEW_READY: 'VIEW_READY',
  VIEW_SPRINT: 'VIEW_SPRINT',
  VIEW_WORK: 'VIEW_WORK',
  VIEW_DEV_COMPLETE: 'VIEW_DEV_COMPLETE',
  VIEW_ACCEPTED: 'VIEW_ACCEPTED',
  VIEW_DEPLOYED: 'VIEW_DEPLOYED',

  OPEN_MODAL: 'OPEN_MODAL',
  UPDATE_MODAL: 'UPDATE_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  CLOSE_ALL_MODALS: 'CLOSE_ALL_MODALS',

  REQUEST_WORK_PACKAGE: 'REQUEST_WORK_PACKAGE',
  REQUEST_WORK_PACKAGE_FAILED: 'REQUEST_WORK_PACKAGE_FAILED',
  REQUEST_WORK_PACKAGE_GRAPHS: 'REQUEST_WORK_PACKAGE_GRAPHS',
  RECEIVE_TARGET_WORK_PACKAGES: 'RECEIVE_TARGET_WORK_PACKAGES',
  RECEIVE_CADENCE_WORK_PACKAGES: 'RECEIVE_CADENCE_WORK_PACKAGES',
  RECEIVE_ALL_WORK_PACKAGES: 'RECEIVE_ALL_WORK_PACKAGES',
  SEND_WORK_PACKAGE: 'SEND_WORK_PACKAGE',
  CANCEL_SEND_WORK_PACKAGE: 'CANCEL_SEND_WORK_PACKAGE',
  ADD_WORK_PACKAGE: 'ADD_WORK_PACKAGE',
  UPDATE_WORK_PACKAGE: 'UPDATE_WORK_PACKAGE',
  UPDATE_MULTIPLE_WORK_PACKAGES: 'UPDATE_MULTIPLE_WORK_PACKAGES',
  UPDATE_WORK_PACKAGE_RANK: 'UPDATE_WORK_PACKAGE_RANK',
  DELETE_WORK_PACKAGE: 'DELETE_WORK_PACKAGE',
  UPDATE_WORK_PACKAGE_LIST: 'UPDATE_WORK_PACKAGE_LIST',
  UPDATE_WORK_PACKAGE_STATUS: 'UPDATE_WORK_PACKAGE_STATUS',
  UPDATE_WORK_PACKAGE_CHILDREN: 'UPDATE_WORK_PACKAGE_CHILDREN',
  REMOVE_CHILDREN_FROM_WORK_PACKAGE: 'REMOVE_CHILDREN_FROM_WORK_PACKAGE',
  DELETE_WORK_PACKAGE_CHILDREN: 'DELETE_WORK_PACKAGE_CHILDREN',
  REPLACE_WORK_PACKAGE_CHILDREN: 'REPLACE_WORK_PACKAGE_CHILDREN',
  SORT_WORK_PACKAGES: 'SORT_WORK_PACKAGES',
  WORK_PACKAGES_INITIAL_STATE: 'WORK_PACKAGES_INITIAL_STATE',
  ADD_WRAP_PARENT: 'ADD_WRAP_PARENT',
  REMOVE_WRAP_PARENT: 'REMOVE_WRAP_PARENT',
  RESET_WRAP_PARENT: 'RESET_WRAP_PARENT',
  ADD_WORK_PACKAGE_METRICS_LEAN: 'ADD_WORK_PACKAGE_METRICS_LEAN',
  ADD_WORK_PACKAGE_METRICS_BURNDOWN: 'ADD_WORK_PACKAGE_METRICS_BURNDOWN',
  ADD_WORK_PACKAGE_METRICS_IDLE: 'ADD_WORK_PACKAGE_METRICS_IDLE',
  ADD_WORK_PACKAGE_METRICS_CUMULATIVE: 'ADD_WORK_PACKAGE_METRICS_CUMULATIVE',
  ADD_WORK_PACKAGE_METRICS_GANTT: 'ADD_WORK_PACKAGE_METRICS_GANTT',
  UPDATE_WORK_PACKAGE_KIND: 'UPDATE_WORK_PACKAGE_KIND',
  REQUEST_ACTIVITY: 'REQUEST_ACTIVITY',
  RECEIVE_ACTIVITY: 'RECEIVE_ACTIVITY',
  RECEIVE_ALL_ACTIVITIES: 'RECEIVE_ALL_ACTIVITIES',
  SEND_ACTIVITY: 'SEND_ACTIVITY',
  UPDATE_ACTIVITY_LIST: 'UPDATE_ACTIVITY_LIST',
  UPDATE_WORK_PACKAGE_RANKS: 'UPDATE_WORK_PACKAGE_RANKS',
  REMOVE_WORK_PACKAGES: 'REMOVE_WORK_PACKAGES',

  ADD_PRODUCT_TO_TEAM_SPACE: 'ADD_PRODUCT_TO_TEAM_SPACE',
  ADD_TEAM_TO_PRODUCT_SPACE: 'ADD_TEAM_TO_PRODUCT_SPACE',
  DELETE_TEAM_FROM_PRODUCT_SPACE: 'DELETE_TEAM_FROM_PRODUCT_SPACE',
  DELETE_PRODUCT_FROM_TEAM_SPACE: 'DELETE_PRODUCT_FROM_TEAM_SPACE',

  REQUEST_TASK: 'REQUEST_TASK',
  REQUEST_TASK_FAILED: 'REQUEST_TASK_FAILED',
  RECEIVE_TASK: 'RECEIVE_TASK',
  RECEIVE_TASKS: 'RECEIVE_TASKS',
  RECEIVE_ALL_TASKS: 'RECEIVE_ALL_TASKS',
  RECEIVE_WORK_PACKAGE_TASKS: 'RECEIVE_WORK_PACKAGE_TASKS',
  SEND_TASK: 'SEND_TASK',
  CANCEL_SEND_TASK: 'CANCEL_SEND_TASK',
  DELETE_TASK: 'DELETE_TASK',
  DELETE_TASK_WITH_ID: 'DELETE_TASK_WITH_ID',
  UPDATE_TASK_LIST: 'UPDATE_TASK_LIST',
  TASKS_INITIAL_STATE: 'TASKS_INITIAL_STATE',
  ADD_TASK_TYPE_TO_TASKS: 'ADD_TASK_TYPE_TO_TASKS',

  REQUEST_ATTACHMENT: 'REQUEST_ATTACHMENT',
  REQUEST_ATTACHMENT_FAILED: 'REQUEST_ATTACHMENT_FAILED',
  RECEIVE_ATTACHMENTS: 'RECEIVE_ATTACHMENTS',
  RECEIVE_ATTACHMENTS_ERROR: 'RECEIVE_ATTACHMENTS_ERROR',
  RECEIVE_ATTACHMENT_FILE: 'RECEIVE_ATTACHMENT_FILE',
  RECEIVE_THUMBNAIL: 'RECEIVE_THUMBNAIL',
  UPLOAD_ATTACHMENT: 'UPLOAD_ATTACHMENT',
  END_UPLOAD_ATTACHMENT: 'END_UPLOAD_ATTACHMENT',
  END_UPLOAD_ATTACHMENT_ERROR: 'END_UPLOAD_ATTACHMENT_ERROR',
  DELETE_ATTACHMENT: 'DELETE_ATTACHMENT',
  END_DELETE_ATTACHMENT: 'END_DELETE_ATTACHMENT',
  SET_ATTACHMENT_COUNTING: 'SET_ATTACHMENT_COUNTING',

  REQUEST_CADENCE: 'REQUEST_CADENCE',
  REQUEST_CADENCE_FAILED: 'REQUEST_CADENCE_FAILED',
  RECEIVE_CADENCES: 'RECEIVE_CADENCES',
  SET_CADENCE: 'SET_CADENCE',
  SET_NEXT_CADENCE: 'SET_NEXT_CADENCE',
  CLEAR_NEXT_CADENCE: 'CLEAR_NEXT_CADENCE',
  UPDATE_CADENCE: 'UPDATE_CADENCE',
  DELETE_CADENCE: 'DELETE_CADENCE',
  SEND_CADENCE: 'SEND_CADENCE',
  NO_CADENCE: 'NO_CADENCE',
  CADENCES_INITIAL_STATE: 'CADENCES_INITIAL_STATE',
  GET_CADENCE_BURNDOWN_DATA: 'GET_CADENCE_BURNDOWN_DATA',

  REQUEST_TARGET: 'REQUEST_TARGET',
  REQUEST_TARGET_FAILED: 'REQUEST_TARGET_FAILED',
  RECEIVE_TARGETS: 'RECEIVE_TARGETS',
  SEND_TARGET: 'SEND_TARGET',
  SET_TARGET: 'SET_TARGET',
  UPDATE_TARGET: 'UPDATE_TARGET',
  ADD_TARGET: 'ADD_TARGET',
  DELETE_TARGET: 'DELETE_TARGET',
  REMOVE_WORK_PACKAGE_FROM_TARGET: 'REMOVE_WORK_PACKAGE_FROM_TARGET',
  REMOVE_WORK_PACKAGES_FROM_TARGET: 'REMOVE_WORK_PACKAGES_FROM_TARGET',
  ADD_WORK_PACKAGE_TO_TARGET: 'ADD_WORK_PACKAGE_TO_TARGET',
  ADD_WORK_PACKAGES_TO_TARGET: 'ADD_WORK_PACKAGES_TO_TARGET',
  ADD_WORK_PACKAGES_TO_TARGETS: 'ADD_WORK_PACKAGES_TO_TARGETS',
  GET_TARGET_BURNUP_DATA: 'GET_TARGET_BURNUP_DATA',

  REQUEST_GOAL: 'REQUEST_GOAL',
  RECEIVE_GOALS: 'RECEIVE_GOALS',
  SEND_GOAL: 'SEND_GOAL',
  SET_GOAL: 'SET_GOAL',

  REQUEST_PRODUCT: 'REQUEST_PRODUCT',
  REQUEST_PRODUCT_FAILED: 'REQUEST_PRODUCT_FAILED',
  RECEIVE_PRODUCTS: 'RECEIVE_PRODUCTS',
  SEND_PRODUCT: 'SEND_PRODUCT',
  SET_PRODUCT: 'SET_PRODUCT',
  SET_CURRENT_PRODUCTS: 'SET_CURRENT_PRODUCTS',
  ADD_WORK_PACKAGE_TO_PRODUCT: 'ADD_WORK_PACKAGE_TO_PRODUCT',
  REMOVE_WORK_PACKAGE_FROM_PRODUCT: 'REMOVE_WORK_PACKAGE_FROM_PRODUCT',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  ADD_PRODUCT: 'ADD_PRODUCT',
  DELETE_PRODUCT: 'DELETE_PRODUCT',

  SET_SELECTED_SPACE: 'SET_SELECTED_SPACE',
  UPDATE_SELECTED_TEAM_SPACE: 'UPDATE_SELECTED_TEAM_SPACE',
  UPDATE_SELECTED_PRODUCT_SPACE: 'UPDATE_SELECTED_PRODUCT_SPACE',
  UPDATE_TEAM_DEFAULT_OPTIONS: 'UPDATE_TEAM_DEFAULT_OPTIONS',
  UPDATE_PRODUCT_TEAMS: 'UPDATE_PRODUCT_TEAMS',

  SET_CURRENT_PRIMARY: 'SET_CURRENT_PRIMARY',

  POPULATE_SAVED_VIEWS: 'POPULATE_SAVED_VIEWS',
  ACTIVATE_SAVED_VIEW: 'ACTIVATE_SAVED_VIEW',
  CREATE_SAVED_VIEW: 'CREATE_SAVED_VIEW',
  DELETE_SAVED_VIEW: 'DELETE_SAVED_VIEW',
  CLEAR_ACTIVE_VIEW: 'CLEAR_ACTIVE_VIEW',
  UPDATE_PLANWALL_STATE: 'UPDATE_PLANWALL_STATE',
  POPULATE_PLANWALL_STATE: 'POPULATE_PLANWALL_STATE',
  CLEAR_FILTERS_ON_SPACE_CHANGE: 'CLEAR_FILTERS_ON_SPACE_CHANGE',
  CHECK_SAVED_VIEWS_FOR_CURRENT_VIEW: 'CHECK_SAVED_VIEWS_FOR_CURRENT_VIEW',
  SWITCH_PRODUCT_TEAM_COLUMNS: 'SWITCH_PRODUCT_TEAM_COLUMNS',
  UPDATE_RIGHT_PANEL_STATE: 'UPDATE_RIGHT_PANEL_STATE',
  SAVED_VIEW_FETCHING: 'SAVED_VIEW_FETCHING',
  ADD_KANBAN_FILTER: 'ADD_KANBAN_FILTER',
  REMOVE_KANBAN_FILTER: 'REMOVE_KANBAN_FILTER',
  CLEAR_KANBAN_FILTER: 'CLEAR_KANBAN_FILTER',
  POPULATE_KANBAN_FILTERS: 'POPULATE_KANBAN_FILTERS',
  RESET_KANBAN_FILTER: 'RESET_KANBAN_FILTER',
  SET_SAVED_KANBAN_FILTERS: 'SET_SAVED_KANBAN_FILTERS',
  UPDATE_SAVED_KANBAN_FILTERS: 'UPDATE_SAVED_KANBAN_FILTERS',
  UPDATE_USER_LOCATION: 'UPDATE_USER_LOCATION',

  REQUEST_CRITERIA: 'REQUEST_CRITERIA',
  REQUEST_CRITERIA_FAILED: 'REQUEST_CRITERIA_FAILED',
  RECEIVE_ACCEPTED_CRITERIA: 'RECEIVE_ACCEPTED_CRITERIA',
  RECEIVE_DONE_CRITERIA: 'RECEIVE_DONE_CRITERIA',
  RECEIVE_READY_CRITERIA: 'RECEIVE_READY_CRITERIA',
  RECEIVE_SHIPPABLE_CRITERIA: 'RECEIVE_SHIPPABLE_CRITERIA',
  RECEIVE_SUCCESS_CRITERIA: 'RECEIVE_SUCCESS_CRITERIA',
  RECEIVE_NEW_ACCEPTED_CRITERIA: 'RECEIVE_NEW_ACCEPTED_CRITERIA',
  RECEIVE_NEW_DONE_CRITERIA: 'RECEIVE_NEW_DONE_CRITERIA',
  RECEIVE_NEW_READY_CRITERIA: 'RECEIVE_NEW_READY_CRITERIA',
  RECEIVE_NEW_SHIPPABLE_CRITERIA: 'RECEIVE_NEW_SHIPPABLE_CRITERIA',
  RECEIVE_NEW_SUCCESS_CRITERIA: 'RECEIVE_NEW_SUCCESS_CRITERIA',
  SEND_CRITERIA: 'SEND_CRITERIA',
  DELETE_CRITERIA: 'DELETE_CRITERIA',
  DELETE_ACCEPTED_CRITERIUM: 'DELETE_ACCEPTED_CRITERIUM',
  DELETE_DONE_CRITERIUM: 'DELETE_DONE_CRITERIUM',
  DELETE_READY_CRITERIUM: 'DELETE_READY_CRITERIUM',
  DELETE_SHIPPABLE_CRITERIUM: 'DELETE_SHIPPABLE_CRITERIUM',
  DELETE_SUCCESS_CRITERIUM: 'DELETE_SUCCESS_CRITERIUM',
  CLEAR_RESULT_CRITERIA: 'CLEAR_RESULT_CRITERIA',
  RECEIVE_TEAM_CRITERIA: 'RECEIVE_TEAM_CRITERIA',

  REQUEST_USER: 'REQUEST_USER',
  REQUEST_USER_FAILED: 'REQUEST_USER_FAILED',
  RECEIVE_USER: 'RECEIVE_USER',
  USER_LOGIN: 'USER_LOGIN',
  USER_AUTH_UPDATE: 'USER_AUTH_UPDATE',
  USER_LOGOUT: 'USER_LOGOUT',
  GET_USER_PROFILE: 'GET_USER_PROFILE',
  UPLOAD_PROFILE_PICTURE: 'UPLOAD_PROFILE_PICTURE',
  UPLOAD_TEAM_PICTURE: 'UPLOAD_TEAM_PICTURE',
  UPLOAD_ORGANIZATION_PICTURE: 'UPLOAD_ORGANIZATION_PICTURE',
  REQUEST_USER_UPDATE: 'REQUEST_USER_UPDATE',
  UPDATE_USER: 'UPDATE_USER',
  CREATE_USER: 'CREATE_USER',
  ADD_USER: 'ADD_USER',
  UPDATE_USER_ERROR: 'UPDATE_USER_ERROR',
  UPDATE_USER_CAPACITY: 'UPDATE_USER_CAPACITY',
  USER_NOT_FETCHING: 'USER_NOT_FETCHING',
  RESET_PASSWORD_ERRORS: 'RESET_PASSWORD_ERRORS',
  LOGIN_ERRORS: 'LOGIN_ERRORS',
  USER_GOT_401: 'USER_GOT_401',
  RESET_USER_401: 'RESET_USER_401',
  UPDATE_USER_ROLES: 'UPDATE_USER_ROLES',
  ROLE_CHANGE: 'ROLE_CHANGE',
  AUTHORIZED_PRODUCT_IDS: 'AUTHORIZED_PRODUCT_IDS',

  REQUEST_DEFAULT_OPTIONS: 'REQUEST_DEFAULT_OPTIONS',
  REQUEST_DEFAULT_OPTIONS_FAILED: 'REQUEST_DEFAULT_OPTIONS_FAILED',
  RECEIVE_DEFAULT_OPTIONS: 'RECEIVE_DEFAULT_OPTIONS',
  RECEIVE_TEAM_DEFAULT_OPTIONS: 'RECEIVE_TEAM_DEFAULT_OPTIONS',
  UPDATE_DEFAULT_OPTIONS: 'UPDATE_DEFAULT_OPTIONS',
  UPDATE_WORKPACKAGE_SEARCH_TEXT: 'UPDATE_WORKPACKAGE_SEARCH_TEXT',
  RESET_WORKPACKAGE_SEARCH_TEXT: 'RESET_WORKPACKAGE_SEARCH_TEXT',
  ADD_CURRENT_PRODUCT: 'ADD_CURRENT_PRODUCT',
  ADD_CURRENT_TEAM: 'ADD_CURRENT_TEAM',
  REMOVE_CURRENT_PRODUCT: 'REMOVE_CURRENT_PRODUCT',
  REMOVE_CURRENT_TEAM: 'REMOVE_CURRENT_TEAM',

  REQUEST_ORGANIZATIONS: 'REQUEST_ORGANIZATIONS',
  REQUEST_ORGANIZATIONS_FAILED: 'REQUEST_FAILED',
  RECEIVE_ORGANIZATIONS: 'RECEIVE_ORGANIZATIONS',
  RECEIVE_ORGANIZATION_USER: 'RECEIVE_ORGANIZATION_USER',
  ORG_USER_ERROR: 'ORG_USER_ERROR',
  REQUEST_ORGANIZATION_CREATE: 'REQUEST_ORGANIZATION_CREATE',
  REQUEST_ORGANIZATION_UPDATE: 'REQUEST_ORGANIZATION_UPDATE',
  UPDATE_ORGANIZATION: 'UPDATE_ORGANIZATION',
  CANCEL_ORGANIZATION_FETCHING: 'CANCEL_ORGANIZATION_FETCHING',
  ADD_TEAM_TO_ORGANIZATION: 'ADD_TEAM_TO_ORGANIZATION',
  UPDATE_DEFAULT_ORG_LEVEL: 'UPDATE_DEFAULT_ORG_LEVEL',

  REQUEST_TEAMS: 'REQUEST_TEAMS',
  REQUEST_TEAMS_FAILED: 'REQUEST_TEAMS_FAILED',
  REQUEST_TEAM_UPDATE: 'REQUEST_TEAM_UPDATE',
  REQUEST_TEAM_CREATE: 'REQUEST_TEAM_CREATE',
  RECEIVE_TEAMS: 'RECEIVE_TEAMS',
  UPDATE_TEAM: 'UPDATE_TEAM',
  ADD_TEAM: 'ADD_TEAM',
  ADD_MEMBER: 'ADD_MEMBER',
  DELETE_TEAM: 'DELETE_TEAM',
  SET_CURRENT_TEAMS: 'SET_CURRENT_TEAMS',
  ADD_NEW_TEAM: 'ADD_NEW_TEAM',
  CLEAR_NEW_TEAM: 'CLEAR_NEW_TEAM',
  REQUEST_TEAM_GRAPHS: 'REQUEST_TEAM_GRAPHS',
  ADD_TEAM_METRICS_BURNDOWN: 'ADD_TEAM_METRICS_BURNDOWN',
  ADD_TEAM_METRICS_CUMULATIVE: 'ADD_TEAM_METRICS_CUMULATIVE',
  ADD_TEAM_METRICS_LEAN: 'ADD_TEAM_METRICS_LEAN',
  ADD_TEAM_METRICS_VELOCITY: 'ADD_TEAM_METRICS_VELOCITY',
  RECEIVE_CHILDREN_PROGRESS: 'RECEIVE_CHILDREN_PROGRESS',
  RECEIVE_FILTERED_CHILDREN_PROGRESS: 'RECEIVE_FILTERED_CHILDREN_PROGRESS',
  ADD_PRODUCT_TO_TEAM: 'ADD_PRODUCT_TO_TEAM',
  REMOVE_PRODUCT_FROM_TEAM: 'REMOVE_PRODUCT_FROM_TEAM',
  UPDATE_TEAM_MEMBER: 'UPDATE_TEAM_MEMBER',

  REQUEST_DEPLOYMENT: 'REQUEST_DEPLOYMENT',
  REQUEST_DEPLOYMENT_FAILED: 'REQUEST_DEPLOYMENT_FAILED',
  RECEIVE_DEPLOYMENTS: 'RECEIVE_DEPLOYMENTS',
  SEND_DEPLOYMENT: 'SEND_DEPLOYMENT',
  SET_DEPLOYMENT: 'SET_DEPLOYMENT',
  ADD_WORK_PACKAGE_TO_DEPLOYMENT: 'ADD_WORK_PACKAGE_TO_DEPLOYMENT',
  REMOVE_WORK_PACKAGE_FROM_DEPLOYMENT: 'REMOVE_WORK_PACKAGE_FROM_DEPLOYMENT',

  TOGGLE_EXPANDED_ITEM: 'TOGGLE_EXPANDED_ITEM',
  EXPAND_ITEM: 'EXPAND_ITEM',
  COLLAPSE_ITEM: 'COLLAPSE_ITEM',
  ADD_LIST_SIZE: 'ADD_LIST_SIZE',
  REMOVE_LIST_SIZE: 'REMOVE_LIST_SIZE',

  TOGGLE_DROP_DOWN_MENU: 'TOGGLE_DROP_DOWN_MENU',
  REMOVE_DROP_DOWN_MENU: 'REMOVE_DROP_DOWN_MENU',
  REMOVE_ALL_DROP_DOWN_MENU: 'REMOVE_ALL_DROP_DOWN_MENU',

  TOGGLE_TRASH: 'TOGGLE_TRASH',

  REQUEST_TASK_TYPE: 'REQUEST_TASK_TYPE',
  RECEIVE_ALL_TASK_TYPES: 'RECEIVE_ALL_TASK_TYPES',
  RECEIVE_TASK_TYPE: 'RECEIVE_TASK_TYPE',

  SHOWING_ORG_WALL: 'SHOWING_ORG_WALL',
  SHOWING_LIST_WALL: 'SHOWING_LIST_WALL',
  TOUR_ACTIVE: 'TOUR_ACTIVE',
  TOUR_INACTIVE: 'TOUR_INACTIVE',
  SHOWING_TOUR_STEP: 'SHOWING_TOUR_STEP',
  CLOSING_TOUR: 'CLOSING_TOUR',
  UPDATE_TOUR_STATE: 'UPDATE_TOUR_STATE',
  USER_WELCOMED: 'USER_WELCOMED'
};

export default actionTypes;
